import { RedirectLoginOptions } from "@auth0/auth0-react";
import TimeFormat from "./components/tripOverview/Common/timeformat";
import { getENVData } from './constants/constantValue';
import { OperationVariables, ApolloQueryResult, NetworkStatus, ApolloError, ServerError } from '@apollo/client';
import type { NormalizedCacheObject, LazyQueryHookExecOptions, QueryResult } from '@apollo/client';
import { NetworkError } from "@apollo/client/errors";

const env = getENVData();
const TIME_CACHED_HEADER = 'TimeCached';

const Helper = {
  loginWithRedirect: {} as (options?: RedirectLoginOptions) => Promise<void>,
  dgraphQUrl: "",
  token: "",
  sendToViator(detail: any) {
    if (!Helper.isValidJwt(Helper.token)) {
      return Helper.loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }

    const viatorDiv = document.getElementById("viatorDiv")!;
    //* const event = document.createEvent("Event");

    const event = new CustomEvent("viator", {
      bubbles: true,
      detail: {
        ...detail,
        ...{ token: Helper.token, dgraphQUrl: Helper.dgraphQUrl },
      },
    });

    if (viatorDiv) {
      const cancelled = !viatorDiv.dispatchEvent(event);

      if (!cancelled) {
        //alert("Got")
      }
    }
  },

  sendToViatorPromise(route: string, props: any = {}) {
    if (!Helper.isValidJwt(Helper.token)) {
      return Helper.loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }

    return new Promise<any>((resolve, reject) => {
      const viatorDiv = document.getElementById("viatorDiv")!;
      const event = new CustomEvent("viator", {
        bubbles: true,
        detail: {
          token: Helper.token,
          dgraphQUrl: Helper.dgraphQUrl,
          route: route,
          props: {
            ...props,
            onResolve: (data: any) => resolve(data),
            onReject: (err: any) => reject(err),
          },
        },
      });

      if (viatorDiv) {
        const cancelled = !viatorDiv.dispatchEvent(event);

        if (cancelled) {
          reject({
            message: "Cancelled",
          });
        }
      } else {
        // reject({
        //     message: "Div not found"
        // });
      }
    });
  },

  sendToExpediaPromise(route: string, props: any = {}) {
    if (!Helper.isValidJwt(Helper.token)) {
      return Helper.loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }

    return new Promise<any>((resolve, reject) => {
      //const expediaDiv = document.getElementById("expediaDiv")!;
      const expediaDiv = document.getElementById("viatorDiv")!;
      //const event = new CustomEvent("expedia", {
      const event = new CustomEvent("viator", {
        bubbles: true,
        detail: {
          token: Helper.token,
          dgraphQUrl: Helper.dgraphQUrl,
          route: route,
          props: {
            ...props,
            onResolve: (data: any) => resolve(data),
            onReject: (err: any) => reject(err),
          },
        },
      });

      if (expediaDiv) {
        const cancelled = !expediaDiv.dispatchEvent(event);

        if (cancelled) {
          reject({
            message: "Cancelled",
          });
        }
      } else {
        // reject({
        //     message: "Div not found"
        // });
      }
    });
  },

  sendToPaymentPromise(route: string, props: any = {}) {
    if (!Helper.isValidJwt(Helper.token)) {
      return Helper.loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }

    return new Promise<any>((resolve, reject) => {
      //const expediaDiv = document.getElementById("expediaDiv")!;
      const expediaDiv = document.getElementById("viatorDiv")!;
      //const event = new CustomEvent("expedia", {
      const event = new CustomEvent("viator", {
        bubbles: true,
        detail: {
          token: Helper.token,
          dgraphQUrl: Helper.dgraphQUrl,
          route: route,
          props: {
            ...props,
            onResolve: (data: any) => resolve(data),
            onReject: (err: any) => reject(err),
          },
        },
      });

      if (expediaDiv) {
        const cancelled = !expediaDiv.dispatchEvent(event);

        if (cancelled) {
          reject({
            message: "Cancelled",
          });
        }
      } else {
        // reject({
        //     message: "Div not found"
        // });
      }
    });
  },

  parseJwt: (token: string): any => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  },

  isValidJwt: (token: string | null): any => {
    if (!token) {
      return false;
    }

    if (token!.length == 0) {
      return false;
    }

    const jwtToken = Helper.parseJwt(token!);

    if (!jwtToken) {
      return false;
    }

    if ((jwtToken.exp - 10) * 1000 <= Date.now()) {
      // remove 10 seconds to avoid issues with clock skew
      return false;
    }

    return true;
  },

  TimeConverter(dateTimeString: string) {
    if (!dateTimeString) {
      return null;
    }

    return TimeFormat(dateTimeString);

    const formattedDateTimeString = dateTimeString.replace(" GMT+0000", "");
    const dateTime = new Date(formattedDateTimeString);
    const hours = dateTime.getHours();

    const minutes = dateTime.getMinutes();
    const period = hours >= 12 ? "PM" : "AM";
    const twelveHourFormat =
      ((hours + 11) % 12) +
      1 +
      ":" +
      (minutes < 10 ? "0" : "") +
      minutes +
      " " +
      period;
    return twelveHourFormat;
  },

  convertDecimalTime(decimalTime: any) {
    if (!decimalTime) {
      return null;
    }

    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 60);

    let result = "";
    if (hours > 0) {
      result += hours === 1 ? "1 hour" : `${hours} hours`;
    }

    if (minutes > 0) {
      result += hours > 0 ? " and " : "";
      result += minutes === 1 ? "1 minute" : `${minutes} minutes`;
    }

    return result;
  },

  async cacheEixsts(fileUrls: string[]): Promise<boolean> {
    try {
      const cache: Cache = await caches.open(Helper.CACHE_NAME);

      const results = await Promise.all(fileUrls.map(async (fileUrl) => {
        const viator = fileUrl.includes('viator.com');
        const expedia = fileUrl.includes('/expedia?confirmationNumber');

        if (viator) {
          const pdfurl = encodeURIComponent(fileUrl.replace('/ticket', '/ticket/download-pdf'));
          fileUrl = `${env.base_api}/misc/proxy?path=${pdfurl}`;
        }

        if (!expedia && !viator) {
          const lastUpdated = await Helper.getFileLastUpdated("travelsment-dev", fileUrl);

          console.log(lastUpdated);
        }

        const response = await cache.match(fileUrl);

        return Boolean(response) ? true : Boolean(response);
      }));

      return results.every(Boolean);
    }
    catch (error: unknown) {
      return false;
    }
  },

  isViator(fileUrl: string): boolean {
    return fileUrl.includes('viator.com');
  },

  isExpedia(fileUrl: string): boolean {
    return fileUrl.includes('/expedia?confirmationNumber');
  },

  async refreshCache(force: boolean, keys: string[]): Promise<(string | null)[]>{
    //const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;
    const EIGHT_HOURS = 8 * 60 * 60 * 1000;

    const cache = await caches.open(Helper.CACHE_NAME);
    //const cacheKeys = await cache.keys();

    const results = await Promise.all(keys.map(async (request) => {
      const response = await cache.match(request);

      if (response) {
        const timeCached = Number(response?.headers.get(TIME_CACHED_HEADER));

        if (force || !timeCached || Date.now() - timeCached > EIGHT_HOURS) {
          await cache.delete(request);

          return request;
        }
        else {
          return null;
        }
      }
      else {
        return request;
      }
    }));

    return Promise.resolve(results.filter(r => r));
  },

  async downloadFileWithCache(fileUrl: string, fileName: string, itineraryData: any, download: boolean = true): Promise<Blob | null> {
    try {
      // 1. Open or create the custom browser cache
      const cache: Cache = await caches.open(Helper.CACHE_NAME);

      var viator = fileUrl.includes('viator.com');
      var expedia = fileUrl.includes('/expedia?confirmationNumber')
      
      if (viator) {
        const pdfurl = encodeURIComponent(fileUrl.replace('/ticket', '/ticket/download-pdf'));

        fileUrl = `${env.base_api}/misc/proxy?path=${pdfurl}`;
      }

      // 2. Check if the file URL already exists in the cache
      let response: Response | undefined = await cache.match(fileUrl);
      let isFromCache = true;

      var headers = {
        'Content-Type': 'application/pdf',
      }

      if (!response) {
          // 3. Cache miss: Fetch from network and save to cache
          isFromCache = false;
          console.log('File not found in cache. Fetching from network...');

          if (viator || expedia) {
              await Helper.loginWithRedirect({ 
                  appState: { 
                      returnTo: window.location.pathname
                  }
              });

              const rspAuth = await fetch(`${env.base_api}/token`, {
                  headers: {
                      'Content-Type': 'application/json',
                      'X-Auth-Token': Helper.token,
                  }
              });

              const jsonAuth = await rspAuth.json();
              const token = jsonAuth.token;

              headers = {
                  ...headers, ...{
                      'Authorization': `Bearer ${token}`,
                  }
              }
          }

          if (expedia && itineraryData) {
            const pdf = await Helper.sendToExpediaPromise("expediaConfirmationPdf", {
                onNotify: (title: string, message: string, type: "success" | "danger" | "info" | "default" | "warning") => {
                    //showMessage(title, message, type);
                },
                params: {
                    itineraryData: itineraryData,
                    endUser: true,
                    download: download,
                    open: false,
                    show: false,
                    processDate: new Date(),
                    cancel: () => {
                        ;
                    }
                }
            });

            if (pdf) {
                response = new Response(pdf, {
                    headers: { 'Content-Type': 'application/pdf' }
                });
            }
          }

          if (!expedia) {
            response = await fetch(fileUrl, {
                headers: headers
            });

            if (!response.ok) throw new Error('Network response was not ok');
          }

          if (response) {
            const cachedHeaders = new Headers(response.headers);
            cachedHeaders.set(TIME_CACHED_HEADER, Date.now().toString());
            const cachedResponse = new Response(await response.clone().blob(), {
              headers: cachedHeaders,
              status: response.status,
              statusText: response.statusText,
            });

            await cache.put(fileUrl, cachedResponse);
          }
      }
      else {
          console.log('File successfully served from local cache!');
      }

      if (response) {
        let blob: Blob = await response.blob();

        if (viator) {
          blob = new File([blob], "download.pdf", { type: 'application/pdf' });
        }

        return blob;
      }

      return null;
    } 
    catch (error: unknown) {
        if (error instanceof Error) {
            console.error('File operation failed:', error.message);
        }
        else {
            console.error('An unexpected error occurred:', error);
        }

        throw error;
    }
  },

  async getFileLastUpdated(bucketName: string, fileKey: string): Promise<Date | undefined> {
    try {        
      return new Date();
    }
    catch (error) {
      console.error(`Failed to fetch metadata for ${fileKey}:`, error);
      throw error;
    }
  },

  async queryWithCache<T>(query: (options: Partial<LazyQueryHookExecOptions<T, OperationVariables>>) => Promise<QueryResult<T, OperationVariables>>,
                        options?: Partial<LazyQueryHookExecOptions<T, OperationVariables>>) : 
                          Promise<QueryResult<T, OperationVariables> & { isFromCache: boolean }> {

    try {
      const result = await query({
        ...options,
        fetchPolicy: 'cache-first'
      });

      const isFromCache = !result.loading && result.networkStatus === NetworkStatus.ready;

      if (result.data) {
        return { ...result, isFromCache: isFromCache };  
      }
    }
    catch(ex: any) {
      console.log(ex.message);
    }

    const fallbackResult = await query({ ...options, fetchPolicy: 'cache-only' });

    return { ...fallbackResult, isFromCache: true };
  },

  CACHE_NAME: 'app-visited-urls-cache'
};

export default Helper;
